import React, { useEffect, useState } from "react";
import raw from '../commit.txt'; 

const CommitInfo = () => {
  const [commitHash, setCommitHash] = useState("Loading...");

  useEffect(() => {
    fetch(raw)
        .then((response) => response.text())
        .then((text) => setCommitHash(text.trim()))
        .catch(() => setCommitHash("Unknown"));
  }, []);

  return (
    <div>
      <span>Commit: {commitHash}</span>
    </div>
  );
};

export default CommitInfo;
